import { Box } from '@palmetto/palmetto-components';

import { ContractDocumentProviders } from 'types';

const PROVIDER_LABELS: Partial<Record<string, string>> = {
  [ContractDocumentProviders.docusign]: 'DocuSign',
  [ContractDocumentProviders.conga]: 'Conga',
};

const ContractEnvelopeSent = ({ event }: { event: { data?: { provider?: string } } }) => {
  const providerLabel = PROVIDER_LABELS[event.data?.provider ?? ''];
  return (
    <Box display="block">
      <Box as="span" display="inline-block" margin="0 2xs 0 0">
        Contract envelope sent{providerLabel ? ` via ${providerLabel}` : ''}
      </Box>
    </Box>
  );
};

export default ContractEnvelopeSent;
